/**
 * MOTOR MESAJININ CÜMLESİ (çok dilli arayüz, 27.10.2026).
 *
 * Motor sebebi KOD + değerler olarak verir (`MotorMesaji`); bu fonksiyon
 * etkin dilin sözlüğünden cümleyi kurar. İç içe mesajlar (bir başarısızlığın
 * sebebi gibi) önce kendi cümlelerine çevrilir; dizi öğeleri virgülle
 * birleşir. Kod sözlükte yoksa İngilizceye, o da yoksa kodun kendisine
 * düşer — ikisini de `motorMesajlari.test.ts` engeller.
 */

import { motorMesajiMi, type MesajDegeri, type MotorMesaji } from "@parafon/contracts/local-api";
import { M, SOZLUKLER } from "./index";
import type { MotorP } from "./tip";

type Girdi = (p: MotorP) => string;

function girdi(kod: string): Girdi | undefined {
  const etkin = (M.motor as Readonly<Record<string, Girdi | undefined>>)[kod];
  return etkin ?? (SOZLUKLER.en.motor as Readonly<Record<string, Girdi | undefined>>)[kod];
}

function degerMetni(v: MesajDegeri): string {
  if (typeof v === "string") return v;
  if (typeof v === "number") return String(v);
  if (Array.isArray(v)) return v.map((x) => motorMetni(x)).join(", ");
  return motorMesajiMi(v) ? motorMetni(v) : String(v);
}

export function motorMetni(m: MotorMesaji): string {
  const f = girdi(m.kod);
  if (f === undefined) return m.kod;
  const p: Record<string, string> = {};
  for (const [k, v] of Object.entries(m.p ?? {})) p[k] = degerMetni(v);
  return f(p);
}

/** Mesaj yoksa yedek metin (ör. "motor sebebini söylemedi"). */
export function motorMetniVeya(m: MotorMesaji | null | undefined, yedek: string): string {
  return m === null || m === undefined ? yedek : motorMetni(m);
}
